export const SOCIAL_EMBED_WIDTH = 500;
export const SOCIAL_EMBED_HEIGHT = 500;
export const SOCIAL_EMBED_HEIGHT_MOBILE = 300;
export const TWITTER_SDK = "https://platform.twitter.com/widgets.js";
export const YOUTUBE_WATCH_URL = "https://www.youtube.com/watch?v=";
